'use client';

import { c as _c } from "react/compiler-runtime";
import { motion, useInView } from 'motion/react';
import { useTranslations } from 'next-intl';
import { useRef } from 'react';
import { buttonVariants } from '@/components/ui/button';
import { Link } from '@/components/ui/link';
import { cn } from '@/utils/cn';
import { CodingHours } from './coding-hours';
import { Connect } from './connect';
import { FavoriteFramework } from './favorite-framework';
import { LocationCard } from './location-card';
import { StacksCard } from './stacks-card';
const variants = {
  initial: {
    y: 40,
    opacity: 0
  },
  animate: {
    y: 0,
    opacity: 1
  }
};
export function AboutMe() {
  const $ = _c(24);
  const cardsRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      once: true,
      margin: "-100px"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isInView = useInView(cardsRef, t0);
  const t = useTranslations();
  const t1 = isInView ? "animate" : "initial";
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      duration: 0.5
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      y: 30,
      opacity: 0
    };
    t4 = {
      y: 0,
      opacity: 1
    };
    t5 = {
      duration: 0.3
    };
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t3 = $[2];
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t) {
    t6 = t("homepage.about-me.title");
    $[5] = t;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t6) {
    t7 = <motion.h2 className="text-center text-3xl font-semibold" initial={t3} animate={t4} transition={t5}>{t6}</motion.h2>;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t10;
  let t8;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      y: 40,
      opacity: 0
    };
    t9 = {
      y: 0,
      opacity: 1
    };
    t10 = {
      duration: 0.3
    };
    $[9] = t10;
    $[10] = t8;
    $[11] = t9;
  } else {
    t10 = $[9];
    t8 = $[10];
    t9 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="grid gap-4"><LocationCard /><StacksCard /></div>;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Connect />;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <motion.div className="mt-12 grid gap-4 md:grid-cols-2" initial={t8} animate={t9} transition={t10}>{t11}<div className="grid gap-4">{t12}<div className="grid gap-4 [@media(min-width:450px)]:grid-cols-2"><CodingHours /><FavoriteFramework /></div></div></motion.div>;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = cn(buttonVariants({
      variant: "outline"
    }));
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] !== t) {
    t15 = t("homepage.about-me.more");
    $[16] = t;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] !== t15) {
    t16 = <div className="my-8 flex items-center justify-center"><Link href="/about" className={t14}>{t15}</Link></div>;
    $[18] = t15;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] !== t1 || $[21] !== t16 || $[22] !== t7) {
    t17 = <motion.div initial="initial" animate={t1} variants={variants} ref={cardsRef} transition={t2} className="relative my-24">{t7}{t13}{t16}</motion.div>;
    $[20] = t1;
    $[21] = t16;
    $[22] = t7;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  return t17;
}